import { apiSlice } from "../../apiSlice";
import type { TagTypes } from "../../apiSlice";

export interface ProjectNotificationPreference {
	id: number;
	project: { id: number; name: string };
	user: { id: number };
	is_subscribed: boolean;
	created_at: string;
	updated_at: string;
}

export interface SetNotificationPreferencePayload {
	project: number;
	is_subscribed: boolean;
}

export const notificationPreferencesApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		// Returns only the current user's rows — the backend scopes the queryset to
		// request.user. A project with no row here is not subscribed: notifications
		// are off until the user turns them on.
		getMyNotificationPreferences: builder.query<ProjectNotificationPreference[], void>({
			query: () => "project-notification-preferences/",
			providesTags: ["NotificationPreferences" as TagTypes],
		}),
		// One POST covers both "subscribe for the first time" and "change my mind":
		// the backend's create() is a get_or_create followed by an update.
		setNotificationPreference: builder.mutation<
			ProjectNotificationPreference,
			SetNotificationPreferencePayload
		>({
			query: (body) => ({
				url: "project-notification-preferences/",
				method: "POST",
				body,
			}),
			invalidatesTags: ["NotificationPreferences" as TagTypes],
		}),
	}),
});

export const {
	useGetMyNotificationPreferencesQuery,
	useSetNotificationPreferenceMutation,
} = notificationPreferencesApiSlice;
